import React, {useEffect, useState} from 'react';
import {connect, useDispatch} from 'react-redux'
import {
    BrandAutoComplete,
    BrandCreate,
    Head,
} from "../../../components";
import {Box, Paper} from "@mui/material";
import {Tooltip} from "@mui/material";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import ReactPaginate from "react-paginate";
import {CURRENT_ATTRIBUTE, CURRENT_BRAND} from "../../../types";
import {brandAction} from "../../../actions";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import Divider from "@mui/material/Divider";
import AccordionActions from "@mui/material/AccordionActions";
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import Api from "../../../utils/api";
import {toast} from "react-toastify";
import DeleteIcon from '@mui/icons-material/Delete';

const Brand = (props) => {

    const { fetchBrands, brandReducer, authReducer} = props;

    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState({});

    useEffect(() => {
        handleRequest();
    }, [page, filter]);

    const handleRequest = () => {
        fetchBrands({
            filter,
            page: page,
        });

        dispatch({type: CURRENT_BRAND, payload: null});
    };

    const handleChangeElementWithAutoComplete = (name, value) => {
        let frm = {...filter};
        if (value) {
            frm['id'] = value.id;
            frm['title'] = value.title;

        } else {
            frm['id'] = '';
            frm['title'] = '';
        }
        setFilter(frm);
    };

    const handleChangeStatus = (id, field) => {
        new Api().put('/products/brands/' + id + '/status', {field}).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    handleRequest()
                    toast.success(response.msg)
                } else {
                    toast.error(response.msg);
                }
            }
        })
    }

    const pageCount = Math.ceil(parseInt(brandReducer.entities?.total) / parseInt(brandReducer.entities?.per_page));


    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'برند ها', 'description': 'برندها را مشخص کنید' }} />
            <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={false}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography >جستجو</Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid xs={12} sm={4}>
                                <BrandAutoComplete onChange={(value) => handleChangeElementWithAutoComplete('id', value)}/>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <Box mt={5}>
                <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                    {authReducer.user.permissions.product && Boolean(authReducer.user.permissions.product.store_product_brands_admin) && <BrandCreate reload={() => handleRequest()}/>}
                    {authReducer.user.permissions.product && Boolean(authReducer.user.permissions.product.update_product_brands_admin) && brandReducer.entity && <Tooltip title="خذف">
                        <IconButton onClick={() => handleChangeStatus(brandReducer.entity, 'deleted')}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>}
                    {authReducer.user.permissions.product && Boolean(authReducer.user.permissions.product.update_product_brands_admin) && brandReducer.entity && <Tooltip title="ویرایش" component={Link} to={'/product/brand/'+ brandReducer.entity + '/edit'}>
                        <IconButton>
                            <EditIcon />
                        </IconButton>
                    </Tooltip>}
                    <Tooltip title="سینک" onClick={() => handleRequest()}>
                        <IconButton>
                            <SyncIcon />
                        </IconButton>
                    </Tooltip>
                </div>
                <Paper elevation={1} style={{ padding: '15px'}}>
                    <Grid container>
                        {brandReducer.entities.data && brandReducer.entities.data.map((item, index) => {
                            return(
                                <Grid key={index} item xs={12} sm={3}>
                                    <FormControlLabel key={index} control={
                                        <Radio
                                            checked={(brandReducer.entity ? brandReducer.entity : false ) === item.id}
                                            value={item.id}
                                            onChange={() => dispatch({type: CURRENT_BRAND, payload: item.id})}
                                        />
                                    } label={item.title ? item.title : item.id} />
                                </Grid>
                            );
                        })}
                    </Grid>
                </Paper>
                <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                    containerClassName={'pagination'}
                    activeClassName={'active'}
                />
            </Box>
        </Container>

    );
}


const mapStateToProps = state => ({
    brandReducer: state.brandReducer,
    authReducer: state.authReducer
});

const mapDispatchToProps = (dispatch) => ({
    fetchBrands: (object) => {
        dispatch(brandAction.fetchBrands(object))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Brand)
